<template>
    <AppModal :name="name"
              :width="1200"
              :beforeOpen="beforeOpen"
              :beforeClose="beforeClose"
              :opened="opened">
        <template slot="header">
            Select an existing {{ isPurchaseOrder ? 'order' : 'receipt' }}
        </template>
        <template slot="content">
            <div class="row">
                <div class="col-4 offset-8">
                    <AppSearchInput
                        :value="query"
                        @input="onSearchChange"
                        class="w-100"/>
                </div>
            </div>
            <div class="row" style="min-height: 354px">
                <div class="col-6 border-right">
                    <div class="text-left my-2">
                        Selected items
                    </div>
                    <div v-if="selectedItems.length === 0" class="text-muted pt-2">
                        No data
                    </div>
                    <div v-else class="items-container scrollable">
                        <MatchingItem
                            v-for="(item, idx) in selectedItems" :key="idx"
                            :item="item"
                            :isSelected="checkIsSelectedItem(item)"
                            @click="onItemClick(item)"/>
                    </div>
                </div>
                <div class="col-6 h-100">
                    <div class="text-left my-2">
                        All results
                    </div>
                    <div v-if="isSearching" class="text-muted pt-2">
                        Loading...
                    </div>
                    <div v-else-if="filteredSearchItems.length === 0" class="text-muted pt-2">
                        No data
                    </div>
                    <RecycleScroller
                        v-else
                        class="items-container"
                        :items="filteredSearchItems"
                        :item-size="40"
                        key-field="uuid"
                        v-slot="{ item }">
                        <MatchingItem
                            :item="item"
                            :isSelected="checkIsSelectedItem(item)"
                            @click="onItemClick(item)"/>
                    </RecycleScroller>
                </div>
            </div>
        </template>

        <template slot="actions">
            <div class="row justify-content-end mx-0">
                <button @click="onCancel" class="btn btn-link mt-1">Cancel</button>
                <button @click="onMatch" class="btn btn-primary mt-1 mr-2">Match</button>
            </div>
        </template>
    </AppModal>
</template>

<script>
import axios from 'axios'
import MatchingItem from '../MatchingItem'
import {MatchingExtensionTypes} from '@/types/document-viewer/extension/matching'
import {ERROR} from '@/store/modules/ui/UI'
import AppSearchInput from '../../../../../../components/shared/AppSearchInput'

export default {
    name: 'DocumentMatchingItemsSelectModal',
    props: {
        name: {
            type: String,
            required: true
        }
    },
    components: {AppSearchInput, MatchingItem},
    data() {
        return {
            type: null,
            query: '',
            isSearching: false,

            items: [],
            selectedItems: [],
            supplierUuid: null,
            onSelect: () => {
            }
        }
    },
    computed: {
        isSupplierReceipt() {
            return this.type === MatchingExtensionTypes.SUPPLIER_RECEIPT
        },

        isPurchaseOrder() {
            return this.type === MatchingExtensionTypes.PURCHASE_ORDER
        },

        filteredSearchItems() {
            return this.items.filter(el => this.selectedItems.every(el2 => el2.uuid !== el.uuid))
        }
    },
    methods: {
        beforeOpen({params}) {
            this.type = _.get(params, 'type', MatchingExtensionTypes.PURCHASE_ORDER)
            if (params && params.searchQuery) {
                this.query = params.searchQuery
            }
            if (_.isArray(params.selectedItems)) {
                this.selectedItems = _.cloneDeep(params.selectedItems)
            }
            if (params.supplierUuid) {
                this.supplierUuid = params.supplierUuid
            }
            if (typeof params.onSelect === 'function') {
                this.onSelect = params.onSelect
            }
            this.searchItems()
        },

        opened() {
            this.$nextTick(() => {
                if (this.$refs['search-query']) {
                    this.$refs['search-query'].focus()
                }
            })
        },

        beforeClose() {
            Object.assign(this.$data, this.$options.data.apply(this))
        },

        onSearchChange(e) {
            this.query = e.target.value
        },

        searchItems() {
            this.isSearching = true
            axios.get('purchase-orders/lines', {
                requestId: 'PO_SEARCH',
                params: {
                    q: this.query,
                    supplier: this.supplierUuid,
                    filter: this.type
                }
            })
                .then(res => {
                    this.items = res.data.data || []
                    this.isSearching = false
                })
                .catch(err => {
                    if (!axios.isCancel(err)) {
                        this.isSearching = false
                        this.$snackbar.show({type: ERROR, text: 'Search error'})
                    }
                })
        },

        onItemClick(item) {
            const idx = this.selectedItems.findIndex(selectedItem => selectedItem.uuid === item.uuid)
            if (idx === -1) {
                this.selectedItems.push(item)
            } else {
                this.selectedItems.splice(idx, 1)
            }
        },

        checkIsSelectedItem(item) {
            return this.selectedItems.some(el => el.uuid === item.uuid)
        },

        async onMatch() {
            this.onSelect(this.selectedItems)
            this.$modal.hide('matching-item-details')
            this.$modal.hide(this.name)
        },

        onCancel() {
            this.$modal.hide(this.name)
        }
    },
    watch: {
        query: 'searchItems'
    }
}
</script>

<style scoped>
button {
    width: 160px;
}

.items-container {
    height: 320px;
    padding: 0;
}
</style>
